import React from 'react';
import ReactECharts from 'components/ThemedECharts';

import { CHART_SERIES_PALETTE } from 'constants/colors';
import { MensalComparativo } from 'types/Relatorios/Mensal';

interface Props { data: MensalComparativo; }

export default function ComparativoChart({ data }: Props) {
  const option = {
    legend: { data: data.series.map((s) => s.nome), bottom: 0 },
    xAxis: { type: 'category', data: data.periodos },
    yAxis: { type: 'value', axisLabel: { formatter: '{value}%' } },
    series: data.series.map((s, i) => ({
      name: s.nome,
      type: 'line',
      data: s.valores,
      color: CHART_SERIES_PALETTE[i % CHART_SERIES_PALETTE.length],
    })),
    tooltip: { trigger: 'axis' },
    grid: {
      left: '8%', right: '5%', top: '8%', bottom: '18%', containLabel: true,
    },
  };

  return <ReactECharts option={option} style={{ height: 240 }} />;
}
